<template>
  <collapsed-section title="Vet Details">
    <error-banner v-if="error" :message="error"/>
    <labeled-form-control label="Name" :optional="true">
      <input v-model="name" class="form-control" type="text" placeholder="Name" :disabled="vetContactUpdated"/>
    </labeled-form-control>
    <labeled-form-control label="Mobile" :optional="true">
      <input v-model="mobile" class="form-control" type="tel" placeholder="Mobile" :disabled="vetContactUpdated"/>
    </labeled-form-control>
    <labeled-form-control label="Address" :optional="true">
      <textarea v-model="otherInfo" class="form-control" cols="50" rows="5" maxlength="50" placeholder="Address" :disabled="vetContactUpdated"></textarea>
    </labeled-form-control>
  </collapsed-section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { VetContactUploadMixin } from '../../mixins/Registration/VetContactUploadMixin'
import { ClientOnboardingInviteCacheMixin } from '@/mixins/Registration/ClientOnboardingInviteCacheMixin'
import CollapsedSection from '../Layout/CollapsedSection.vue'
import LabeledFormControl from '../Layout/LabeledFormControl.vue'
import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue'

export default {
  name: 'ClientVetContactSection',
  mixins: [VetContactUploadMixin, ClientOnboardingInviteCacheMixin],
  computed: {
    ...mapState('ApplicationEvents', [
      'saveRegistrationEvent'
    ]),
    ownerId () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.clientId : ''
    }
  },
  watch: {
    saveRegistrationEvent () {
      this.handleUpdateEvent()
    },
    petNoteUpdated () {
      this.handleUpdateEvent()
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setVetContactUpdated'
    ]),
    afterUpdateVetContact () {
      this.setVetContactUpdated()
    },
    afterAddVetContact () {
      this.setVetContactUpdated()
    },
    handleUpdateEvent () {
      if (!this.vetContactUpdated && this.petNoteUpdated) {
        this.tryUploadVetContact()
      }
    }
  },
  components: {
    'collapsed-section': CollapsedSection,
    'labeled-form-control': LabeledFormControl,
    'error-banner': ErrorBanner
  }
}
</script>
